import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

export default (store) => Bugsnag.start({
  apiKey: process.env.MIX_BUGSNAG_VUE_API_KEY,
  plugins: [new BugsnagPluginVue()],
  onError: function (event) {
    if(event.originalError.isAxiosError){
      return false;
    }
    let user = store.state.auth && store.state.auth.user ? store.state.auth.user : {};
    event.addMetadata('user', {
      id:user.id,
      grade: user.grade,
      name: user.name,
      school: user.school,
    })
  }
});
